import { Button } from "@crew/ui/components/button";
import { Share, SquarePlus, X } from "lucide-react";
import { useInstall } from "../../app/install";

/**
 * Put Crew on the home screen (PWA phase 1), on a phone only: Chrome's own prompt on
 * Android, the Share sheet's steps on iOS. Gone once installed, dismissed, or (on iOS,
 * which never says) once they say they've added it.
 */
export function InstallCard() {
  const { way, install, dismiss } = useInstall();
  if (!way) return null;
  return (
    <section
      aria-label="Install Crew"
      className="relative flex gap-4 rounded-well bg-muted p-5 pr-12 md:hidden"
    >
      <img src="/hq/icons/icon-192.png" alt="" className="size-12 shrink-0 rounded-xl" />
      <div className="flex min-w-0 flex-col gap-1">
        <p className="text-lead text-foreground">Put Crew on your home screen</p>
        {way === "prompt" ? (
          <>
            <p className="text-body text-muted-foreground">
              It opens like an app, full screen, one tap away.
            </p>
            <Button className="mt-2 self-start" onClick={() => void install()}>
              Install
            </Button>
          </>
        ) : (
          <>
            <p className="text-body text-muted-foreground">
              Tap <Share aria-label="Share" className="mb-1 inline size-4" />, then{" "}
              <span className="whitespace-nowrap">
                Add to Home Screen <SquarePlus aria-hidden className="mb-1 inline size-4" />
              </span>
              . You'll sign in once inside the app.
            </p>
            {/* iOS tells this tab nothing once it's added (the app keeps its own storage), so they say. */}
            <Button variant="outline" className="mt-2 self-start" onClick={dismiss}>
              I've added it
            </Button>
          </>
        )}
      </div>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Not now"
        onClick={dismiss}
        className="absolute top-3 right-3 text-muted-foreground"
      >
        <X />
      </Button>
    </section>
  );
}
